export interface AsyncValue<T, E = any> {
    readonly state: AsyncState;
    readonly value?: T;
    readonly error?: E;
}

export enum AsyncState {
    IDLE = 'IDLE',
    FETCHING = 'FETCHING',
    FETCHED = 'FETCHED',
    ERROR = 'ERROR'
}
